import React, { useEffect, useState, useRef } from 'react';
import API from '../../../utils/API'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import constants from '../../../utils/constants'
import { FormattedMessage } from 'react-intl';
import Toast from '../../../components/Toast/Toast';
import CopyIcon from '../../../assets/icons/common/copy.svg';
import EyeIcon from '../../../assets/icons/common/eye.svg';
import EyeOffIcon from '../../../assets/icons/common/eye-off.svg';
import './Configuration.css'

const Configuration = (props) => {
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission)=>{
    return permission.id
  });

  let [apiKey, setApiKey] = useState('');
  let [success, setSuccess] = useState('');
  let [error, setError] = useState('');
  let [showApiKey, setShowApiKey] = useState(false);
  let [crisisGoClientUID, setCrisisGoClientUID] = useState('');

  useEffect(() => {
    if(!permissionIds.includes(constants.permissionIds.aPlusEdit)){
      navigate('/forbidden');
    };
  }, [navigate, permissionIds]);

  useEffect(() => {
    getApiKey();
    getCrisisGoClientUID();
  }, [])

  const getApiKey = () => {
    API.getCrisisGoApiKey().then((response) => {
      if(response.data.success){
        setApiKey(response.data.apiKey);
      }
    }).catch((error) => {
      console.error('Error getting CrisisGo API key:', error);
    });
  }

  const getCrisisGoClientUID = () => {
    API.getCrisisGoClientUID().then((response) => {
      if(response.data.success){
        setCrisisGoClientUID(response.data.clientUID);
      }
    }).catch((error) => {
      console.error('Error getting CrisisGo client UID:', error);
    });
  }

  const generateApiKey = () => {
    API.generateCrisisGoApiKey(user.email, user.id).then((response) => {
      console.log('response:', response);
      if(response.data.success){
        setApiKey(response.data.apiKey);
        setSuccess(<FormattedMessage id="generateApiKeySuccess" defaultMessage="Successfully generated an API Key" />)
      }
    }).catch((error) => {
      console.error('Error generating CrisisGo API key:', error);
      setError(<FormattedMessage id="generateApiKeyError" defaultMessage="Error generating API key" />)
    });
  }

  const copyApiKey = () => {
    navigator.clipboard.writeText(apiKey);
    setSuccess(<FormattedMessage id="apiKeyCopied" defaultMessage="API Key copied to clipboard" />)
  }

  const handleUpdateCrisisGoUID = async () => {
    try {
      console.log('updating crisisgo client uid:', crisisGoClientUID)
      await API.updateCrisisGoClientUID(crisisGoClientUID);
      setSuccess(<FormattedMessage 
        id="CRISISGO_UID_UPDATED" 
        defaultMessage="CrisisGo Client UID updated successfully" 
      />);
    } catch (error) {
      setError(<FormattedMessage 
        id="CRISISGO_UID_UPDATE_ERROR" 
        defaultMessage="Failed to update CrisisGo Client UID" 
      />);
      console.error('Error updating CrisisGo Client UID:', error);
    }
  }

  return (
    <>
      <div className="title"><FormattedMessage id="CONFIGURATION" defaultMessage="CONFIGURATION" /></div>
      <div className="cardContainer">
        <div className="custom-card-header">
          <FormattedMessage id="SB_CLOUD_API_KEY" defaultMessage="SB Cloud API Key" />
        </div>
        <div className="blueWhiteButton mb-3" id="generateApiKeyBtn" onClick={generateApiKey}>
          <FormattedMessage id="GENERATE_API_KEY" defaultMessage="Generate API Key" />
        </div>
        <div className="grayInputField d-flex justify-content-between align-items-center" >
          <div className={`text-start ${apiKey ? 'api-key-display' : 'api-key-placeholder'}`}>
            {apiKey ? (showApiKey ? apiKey : '•'.repeat(Math.min(apiKey.length, 40))) : (
              <FormattedMessage id="NO_API_KEY" defaultMessage="No API Key" />
            )}
          </div>
          <div className="button-group">
            <button 
              className="copy-button" 
              onClick={() => setShowApiKey(!showApiKey)}
              disabled={!apiKey}
            >
              {showApiKey ? (
                <img src={EyeOffIcon} alt={<FormattedMessage id="HIDE" defaultMessage="Hide" />} />
              ) : (
                <img src={EyeIcon} alt={<FormattedMessage id="SHOW" defaultMessage="Show" />} />
              )}
            </button>
            <button 
              className="copy-button" 
              onClick={copyApiKey}
              disabled={!apiKey}
            >
              <img src={CopyIcon} alt={<FormattedMessage id="COPY" defaultMessage="Copy" />} />
            </button>
          </div>
        </div>
        <p className="row text-muted mt-4 mb-2">
          <FormattedMessage 
            id="API_KEY_DOCS_REFERENCE" 
            defaultMessage="Please refer to the your documentation on how to configure CrisisGo Connect" 
          />
        </p>
      </div>
      {/* <div className="cardContainer mt-4">
        <div className="custom-card-header">
          <FormattedMessage id="CRISISGO_CLIENT_UID" defaultMessage="CrisisGo Client UID" />
        </div>
        <div className="grayInputField d-flex justify-content-between align-items-center">
          <div className="flex-grow-1">
            <input
              type="text"
              className="form-control border-0 bg-transparent p-0"
              id="crisisGoClientUIDInput"
              value={crisisGoClientUID || ''}
              onChange={(e) => {
                // console.log('input changed:', e.target.value);
                setCrisisGoClientUID(e.target.value);
              }}
              placeholder="Enter CrisisGo Client UID"
            />
          </div>
          <button
            className="blueWhiteButton ms-2"
            id="updateCrisisGoUIDBtn"
            onClick={handleUpdateCrisisGoUID}
            // disabled={!crisisGoClientUID}
          >
            <FormattedMessage id="SAVE" defaultMessage="Save" />
          </button>
        </div>
      </div> */}
      <Toast 
        success={success}
        error={error}
        setSuccess={setSuccess}
        setError={setError}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(Configuration);